import { REGISTER, LOGIN, KYC } from "../actions/types";
import { takeLatest, call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import {
  setUser,
  setRegisterError,
  setLoginError,
  getKyc,
  setKyc,
  logout,
} from "../actions/Auth";
import {
  loadingFetch,
  loadingFail,
  loadingSuccess,
  loadingFinish,
} from "../actions/Loading";
import options from "../../helpers/toastConfig";

import axios from "axios";
import { toast } from "react-toastify";
import { authHeader, authUser } from "../../lib/authHeader";

import { createBrowserHistory } from "history";
const history = createBrowserHistory({ forceRefresh: true });
const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

// const headers = authHeader();

function* registerUser({payload, history}) {
  const apiUrl = `${API_BASE}/register`;

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload);

      return result.data;
    } catch (err) {
      // console.log( err.response.data)
      throw err;
    }
  };

  try {
    // yield put(loadingFetch())
    const result = yield call(apiCall);
    // flag one represents registration
    // console.log(result);
    if (result.status !== "error") {
      const payload = { result, flag: 1 };
      yield put(setUser(payload));
      // yield put(loadingSuccess())
      toast.success("Registration Successful", options);
      history.push("/login");
    } else {
      throw result.message;
    }
  } catch (err) {
    // yield put(loadingFail)
    // console.log(err.response)
    let error = err;
    yield put(setRegisterError(err));
    if (typeof err === "object") {
      error = "An error occured. Pls try again";

      if (err.response && err.response.status === 400) {
        const values = Object.values(err.response.data);
        values.map((val) => {
          toast.error(val[0]);
        });
      }
    } else {
      toast.error(error);
    }
  } finally {
    yield put(loadingFinish());
  }
}

function* loginUser({payload, history}) {
  const headers = authHeader();

  const apiUrl = `${API_BASE}/login`;

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload);

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    //  yield put(setUser({flag:2,result: {user: "Joye", token : "abubukdehwh"}}))
    //  yield put(getKyc())

    const result = yield call(apiCall);
    // flag two represents login
    if (result.status !== "error") {
      const payload = { result: result.data, flag: 2 };
      yield put(setUser(payload));
      setTimeout(() => {
        logout();
        toast.info("Your session has expired . Pls login", options);
        history.push("/login");
      }, 60 * 60 * 1000);
      // yield put(getKyc())
      if (result.data.user.bvn) {
        //flag 1 indicates onboarding done proceed to dashboard
        yield put(setKyc(1));
      } else {
        yield put(setKyc(2));
      }
      // yield put(loadingSuccess())
      toast.success("Welcome to Threadigit", options);
    } else {
      throw result.message;
    }
  } catch (err) {
    let error = err;
    if (typeof err === "object") {
      if (err.response && err.response.data && err.response.data.message) {
        error = err.response.data.message;
      } else if (
        err.response &&
        err.response.data &&
        err.response.data.status
      ) {
        error = err.response.data.status;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error, options);
    yield put(setLoginError());
  } finally {
    yield put(loadingFinish());
  }
}

function* handleGetKyc() {
  const apiUrl = `${API_BASE}/profile/kyc/view`;
  const { user } = authUser();
  const headersParam = authHeader();
  const user_id = user.id;
  const headers = { ...headersParam, user_id };
  // console.log("user", user_id);

  // alert('here')
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, { headers });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    // yield put(loadingFetch())
    const result = yield call(apiCall);
    if (result.status !== "error") {
      //check if kyc data exist
      if (result.data.verified !== 0) {
        //flag 1 indicates onboarding done proceed to dashboard
        //if so then set they kyc flag as 1
        yield put(setKyc(1));
      } else {
        //flag 2 indicates onboarding not done proceed to onboarding
        //set the kyc with  flag 2
        yield put(setKyc(2));
      }
    } else {
      // yield put()
      throw result.message;
    }
  } catch (err) {
    toast.error(err, options);
    // yield put(loadingFail)
  }
}

function* handleResetPassword({ payload, history }) {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}reset/password`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      toast.success(result.data.message, options);
      setTimeout(() => {
        history.push("/login");
      }, 3500);
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

const userSaga = [
  takeLatest(REGISTER.REGISTER, registerUser),
  takeLatest(LOGIN.LOGIN, loginUser),
  // takeLatest(KYC.FETCH, handleGetKyc),
  takeLatest(LOGIN.RESET_PASSWORD, handleResetPassword),
];

export default userSaga;
